import React, { useContext } from "react";
import { Paper, Tabs, Tab, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { MedicalKitIcon, RequestIcon, ProfileIcon, ClockIcon } from "../icons";
import { PathContext } from "../context";

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const options = (value) => [
  {
    label: "Botiquín",
    Icon: () => <MedicalKitIcon color={value === 0 ? "#2196C0" : "#192A7F"} />,
    href: "/",
  },
  // { label: "Solicitar", Icon: () => <RequestIcon color={value === 1 ? "#2196C0" : "#192A7F"} />, href: "/request" },
  {
    label: "Historial",
    Icon: () => <ClockIcon color={value === 2 ? "#2196C0" : "#192A7F"} />,
    href: "/history",
  },
  {
    label: "Perfil",
    Icon: () => <ProfileIcon color={value === 3 ? "#2196C0" : "#192A7F"} />,
    href: "/profile",
  },
];

export default function TabBar(props) {
  const { onClick } = props;
  const { tabState, setTab } = useContext(PathContext);
  const classes = useStyles(props)();
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setTab({ index: newValue });
  };

  const onClickTab = (option) => {
    history.push(option.href);
    onClick();
  };

  return (
    <Paper square className={classes.root}>
      <Tabs
        value={tabState.index}
        onChange={handleChange}
        variant="fullWidth"
        TabIndicatorProps={{ style: { display: "none" } }}
        aria-label="icon tabs example"
      >
        {options(tabState.index).map((option, index) => (
          <Tab
            key={index}
            onClick={() => onClickTab(option)}
            label={option.label}
            className={classes.tab}
            style={{ color: tabState.index === index ? "#2196C0" : "#192A7F" }}
            icon={<option.Icon />}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
    </Paper>
  );
}

const useStyles = (props) =>
  makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      zIndex: 1200,
      position: "fixed",
      bottom: 0,
      width: "100%",
      backgroundColor: "#FFF",
      boxShadow: "0px -5px 7px rgba(198, 198, 198, 0.25)",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    },
    tab: {
      opacity: 1,
      "& span": {
        [theme.breakpoints.down("sm")]: {
          fontSize: "0.625rem",
        },
      },
    },
    badge: {
      "& > .MuiBadge-anchorOriginTopRightRectangle": {
        top: -30,
        right: 5,
      },
    },
    // necessary for content to be below app bar
  }));
